import { useQuery } from '@tanstack/react-query';
import { PkBox, PkButton } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import { getEditorialByTagQuery } from '@queries/editorial';
import { withErrorBoundary } from '@shared/ErrorBoundary';
import { competitionCode } from '@utilities/WindowContext';

import * as styles from './styles.module.scss';

const TICKETING_LANG_TAG = `${competitionCode}.TICKETING.LANG`.toUpperCase();

const LanguageDisclaimer = () => {
  const { data: article } = useQuery(getEditorialByTagQuery(TICKETING_LANG_TAG));

  const links = useMemo(() => article?.document?.content.filter((elem) => elem._type === 'LINK'), [article]);

  if (!article?.id) {
    return null;
  }

  return (
    <div className='pk-bg--background pk-py--l pk-py-md--xl2 pk-container'>
      <PkBox
        rounded='xl'
        backgroundColor='elevation-01'
        className='pk-col pk-col--span-12 pk-col--span-md-10 pk-col--offset-md-1'
      >
        <div className='pk-d--flex pk-w--100 pk-p-md--l pk-flex--column-reverse pk-flex-sm--row pk-align-items--center'>
          <div className='pk-flex--grow-1'>
            <div className='pk-text--text-02 pk-mb--m pk-font-size--s pk-font-size-sm--m'>{article.description}</div>
            <div
              className={clsx(
                styles.latestInfo,
                'pk-text--text-01 pk-font--base-bold pk-font-size--xl pk-font-size-sm--xl2 pk-mb--m pk-mb-sm--xl2',
              )}
            >
              {article.title}
            </div>

            {links.map((link) => (
              <PkButton
                key={link._text}
                linkHref={link._attributes.href}
                linkTarget='_blank'
                appearance='outlined'
                className={clsx(styles.button, links.length > 2 && styles.column)}
              >
                {link._text}
              </PkButton>
            ))}
          </div>

          <figure>
            <img className={styles.pic} src={article.imageUrl} alt={article?.mainMedia?.title} />
          </figure>
        </div>
      </PkBox>
    </div>
  );
};

export default withErrorBoundary(memo(LanguageDisclaimer));
